import { DeleteOutline } from '@mui/icons-material';
import './SavedSelectionBar.css';

export function SavedSelectionAction({ children = 'Remove', destructive = false, busy = false, disabled, onClick }) {
    return <button type='button'
        className={`savedSelectionAction${destructive ? ' savedSelectionActionDestructive' : ''}`}
        disabled={disabled || busy} aria-busy={busy || undefined} onClick={onClick}>
        {busy ? <span className='savedSelectionSpinner' aria-hidden='true' /> : destructive && <DeleteOutline aria-hidden='true' />}
        <span>{busy ? 'Removing…' : children}</span>
    </button>;
}

export default function SavedSelectionBar({ children }) {
    return <>
        <div className='savedSelectionBarSpacer' />
        <div className='savedSelectionBar' role='group' aria-label='Selected item actions'>{children}</div>
    </>;
}
